<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { ParameterCard } from '@Shelly/shelly-design-system/index';
	//Components
	import ThumbLayerChart from 'src/components/Chart/LayerChart/ThumbLayerChart.svelte';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { Device } from 'src/types/Device';
	import type { ChartConfigInterface } from 'src/types/Chart';

	export let device: Device,
		deviceChartsConfig: ChartConfigInterface[],
		handleOnClickThumbChart: (e: CustomEvent | Event) => void,
		statuses;

	$: mainLabel = statuses.find((i) => i.mainLabel);
</script>

{#if mainLabel}
	{#if deviceChartsConfig.length}
		<ThumbLayerChart {device} {deviceChartsConfig} legacyStyle on:click={handleOnClickThumbChart} />
	{/if}
	<ParameterCard
		icon={mainLabel.icon}
		iconColor={mainLabel?.iconColor || ''}
		title={capFirstChar(mainLabel.value)}
		description={capFirstChar(
			$format(`title_chart_${mainLabel.peripheralType}`, {
				default: mainLabel.peripheralType,
			}) || '',
		)}
	/>
{/if}
